import { code } from "@spscommerce/utils";

export const SpsListToolbarExamples = {
    basic: {
        label: "Simple Search Toolbar",
        description: code`
            <p>Most commonly there will be a simple search/filter text input.</p>
        `,
        examples: {
            basic: {
                template: code`
                    <sps-list-toolbar>
                        <sps-list-toolbar-search (formSubmit)="handleSearch()">
                            <sps-text-input
                            name="search_text"
                            [(ngModel)]="simpleSearchValue"
                            placeholder="Type here to search for something"
                            ></sps-text-input>
                            <sps-button type="submit" kind="icon" icon="search"></sps-button>
                        </sps-list-toolbar-search>
                        <sps-button-group>
                            <sps-button kind="link">Link Button</sps-button>
                            <sps-button kind="icon" icon="sort-alpha-asc" aria-label="Sort"></sps-button>
                            <sps-button kind="icon" icon="list-table" aria-label="Switch View"></sps-button>
                            <sps-button kind="icon" icon="column-switcher" aria-label="Customize Columns"></sps-button>
                            <sps-button>Button</sps-button>
                        </sps-button-group>
                    </sps-list-toolbar>
                `,
                class: code`
                    class DemoComponent {
                        simpleSearchValue = "stuff";
                        handleSearch(event) {
                            console.log(this.simpleSearchValue)
                        }
                    }
                `
            }
        }
    },
    noSearch: {
        label: "Without Search/Filter",
        description: code`
            <p>You can also use the List Toolbar with no search or filter at all, if
            you have other controls such as sorting that the user needs access to.</p>
        `,
        examples: {
            noSearch: {
                template: code`
                    <sps-list-toolbar>
                        <sps-button-group>
                          <sps-button kind="link">Link Button</sps-button>
                          <sps-button kind="icon" icon="sort-alpha-asc" aria-label="Sort"></sps-button>
                          <sps-button kind="icon" icon="list-table" aria-label="Switch View"></sps-button>
                          <sps-button kind="icon" icon="column-switcher" aria-label="Customize Columns"></sps-button>
                          <sps-button>Button</sps-button>
                        </sps-button-group>
                    </sps-list-toolbar>
                `
            }
        }
    },
    withTabs: {
        label: "Toolbar With Tabs",
        examples: {
            withTabs: {
                template: code`
                    <sps-list-toolbar [tabs]="tabs" [activeTab]="activeTab" (tabChange)="onTabChange($event)">
                        <sps-list-toolbar-search (formSubmit)="handleSearch()">
                            <sps-text-input
                            name="search_text"
                            [(ngModel)]="simpleSearchValue"
                            placeholder="Type here to search for something"
                            ></sps-text-input>
                            <sps-button type="submit" kind="icon" icon="search"></sps-button>
                        </sps-list-toolbar-search>
                        <sps-button-group>
                          <sps-button kind="link">Link Button</sps-button>
                          <sps-button kind="icon" icon="sort-alpha-asc" aria-label="Sort"></sps-button>
                          <sps-button kind="icon" icon="list-table" aria-label="Switch View"></sps-button>
                          <sps-button kind="icon" icon="column-switcher" aria-label="Customize Columns"></sps-button>
                          <sps-button>Button</sps-button>
                        </sps-button-group>
                    </sps-list-toolbar>
                `,
                class: code`
                    class DemoComponent {
                        simpleSearchValue = "stuff";
                        tabs = [
                            {
                                label: "Tab A",
                                icon: "heart red200"
                            },
                            {
                                label: "Tab B"
                            },
                            {
                                label: "Tab C",
                                tag: "23"
                            }
                        ];
                        activeTab = { label: "Tab C", tag: "23" }
                        onTabChange(newTab) {
                            console.log("new tab: ", newTab);
                        }
                        handleSearch(event) {
                            console.log(this.simpleSearchValue)
                        }
                    }
                `
            }
        }
    },
    withTitle: {
        label: "Toolbar with Title",
        examples: {
            noSearch: {
                template: code`
                    <sps-list-toolbar [title]="'SIMPLE SEARCH'">
                        <sps-button-group>
                          <sps-button kind="link">Link Button</sps-button>
                          <sps-button kind="icon" icon="sort-alpha-asc" aria-label="Sort"></sps-button>
                          <sps-button kind="icon" icon="list-table" aria-label="Switch View"></sps-button>
                          <sps-button kind="icon" icon="column-switcher" aria-label="Customize Columns"></sps-button>
                          <sps-button>Button</sps-button>
                        </sps-button-group>
                    </sps-list-toolbar>
                `
            }
        }
    },
    otherInputs: {
        label: "Search/Filter Alternatives",
        description: code`
            <p>You can use other types of inputs aside from text inputs for
            the simple search/filter, such as the Select and the Autocomplete.</p>
        `,
        examples: {
            select: {
                template: code`
                    <sps-list-toolbar>
                        <sps-list-toolbar-search>
                            <sps-select
                            [options]="filterKeys"
                            [(ngModel)]="selectedColor"
                            ></sps-select>
                            <sps-text-input
                            icon="filter"
                            placeholder="Type here to filter"
                            ></sps-text-input>
                        </sps-list-toolbar-search>
                        <sps-button-group>
                            <sps-button kind="link">Link Button</sps-button>
                            <sps-button kind="icon" icon="sort-alpha-asc" aria-label="Sort"></sps-button>
                            <sps-button kind="icon" icon="list-table" aria-label="Switch View"></sps-button>
                            <sps-button kind="icon" icon="column-switcher" aria-label="Customize Columns"></sps-button>
                            <sps-button>Button</sps-button>
                        </sps-button-group>
                    </sps-list-toolbar>
                `,
                class: code`
                    class DemoComponent {
                        filterKeys = ["Document Type", "Sender Name", "Receiver Name"]
                    }
                `
            },
            autocomplete: {
                template: code`
                    <sps-list-toolbar>
                        <sps-list-toolbar-search (formSubmit)="handleSearch()">
                            <sps-autocomplete
                            [suggestions]="colors"
                            [(ngModel)]="color"
                            placeholder="Enter a color"
                            >
                            </sps-autocomplete>
                            <sps-button type="submit" kind="icon" icon="search"></sps-button>
                        </sps-list-toolbar-search>
                        <sps-button-group>
                            <sps-button kind="link">Link Button</sps-button>
                            <sps-button kind="icon" icon="sort-alpha-asc" aria-label="Sort"></sps-button>
                            <sps-button kind="icon" icon="list-table" aria-label="Switch View"></sps-button>
                            <sps-button kind="icon" icon="column-switcher" aria-label="Customize Columns"></sps-button>
                        </sps-button-group>
                    </sps-list-toolbar>
                `,
                class: code`
                    class DemoComponent {
                        colors = ["red", "blue", "green"]
                        color = "blue"
                        handleSearch(event) {
                            console.log(this.color)
                        }
                    }
                `
            }
        }
    },
};
